import { render, staticRenderFns } from "./View.vue?vue&type=template&id=a0d73600"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0d73600')) {
      api.createRecord('a0d73600', component.options)
    } else {
      api.reload('a0d73600', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=a0d73600", function () {
      api.rerender('a0d73600', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messaging/View.vue"
export default component.exports